import API from 'services/api';

export const upsertReservationDocumentsNote = ({
  reservationId,
  payload,
}: {
  reservationId: string | undefined;
  payload: { noteAgency: string; noteSupplier: string };
}) => API.put(`/api/accommodation/calculations/${reservationId}/documents/vaucer/notes`, payload);
